import React from 'react';
import { Box, Avatar, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import JoinFullIcon from '@mui/icons-material/JoinFull';

const getInitials = (name = '') =>
  name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

const RailItem = ({ selected, onClick, label, avatarSx = {}, children }) => (
  <Box
    onClick={onClick}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 0.5,
      cursor: 'pointer',
      flexShrink: 0,
      minWidth: 68,
    }}
  >
    <Box
      sx={{
        width: 60,
        height: 60,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px solid',
        borderColor: selected ? 'primary.main' : 'transparent',
        transition: 'border-color .15s ease, transform .15s ease',
        '&:hover': { transform: 'scale(1.04)' },
      }}
    >
      <Avatar sx={{ width: 52, height: 52, fontWeight: 600, ...avatarSx }}>
        {children}
      </Avatar>
    </Box>
    <Typography
      variant="caption"
      noWrap
      sx={{
        maxWidth: 68,
        fontWeight: selected ? 700 : 500,
        color: selected ? 'primary.main' : 'text.secondary',
      }}
    >
      {label}
    </Typography>
  </Box>
);

const CircleRail = ({
  circles = [],
  selectedId,
  viewMode,
  onSelectCircle,
  onShowIntersections,
  onCreateCircle,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 1.5,
      pb: 1,
      mb: 2,
    }}
  >
    {circles.map(circle => (
      <RailItem
        key={circle.id}
        selected={viewMode === 'circle' && selectedId === circle.id}
        onClick={() => onSelectCircle(circle.id)}
        label={circle.name}
        avatarSx={{ bgcolor: circle.color }}
      >
        {getInitials(circle.name)}
      </RailItem>
    ))}

    <RailItem
      selected={viewMode === 'intersections'}
      onClick={onShowIntersections}
      label="Overlap"
      avatarSx={{ bgcolor: 'background.default', color: 'text.secondary', border: '1px dashed', borderColor: 'divider' }}
    >
      <JoinFullIcon />
    </RailItem>

    <RailItem
      onClick={onCreateCircle}
      label="New circle"
      avatarSx={{ bgcolor: 'transparent', color: 'text.secondary', border: '2px dashed', borderColor: 'divider' }}
    >
      <AddIcon />
    </RailItem>
  </Box>
);

export default CircleRail;
